import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrModalV2, { MODAL_THEME_FIXED_FOOTER_BUTTON } from 'client/components/SrModalV2/SrModalV2';
import { SR_BUTTON_THEME_ADOBE_GREY } from 'client/components/SrButton/SrButton';
import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrSimpleTextTag from 'client/components/SrSimpleTextTag/SrSimpleTextTag';
import SrInstructionsText from 'client/components/SrInstructionsText/SrInstructionsText';

import './SrPartnerComboLockboxInstructionsModal.less';

const SrPartnerComboLockboxInstructionsModal = ({
  onClose,
  comboLockboxPhotoUrl,
  comboLockboxCode,
  sunlockInstalled,
}) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <SrModalV2
      theme={MODAL_THEME_FIXED_FOOTER_BUTTON}
      buttonTheme={SR_BUTTON_THEME_ADOBE_GREY}
      onClose={onClose}
      contentPadding='26px 20px 260px'
    >
      <SrBox styleName='SrPartnerComboLockboxInstructionsModal'>
        <SrBox paddingRight='48px'>
          <SrText
            size='30'
            lineHeight='36px'
            display='block'
            weight='800'
          >
            Combo Lockbox Instructions
          </SrText>
        </SrBox>
        <SrBox marginTop='8px'>
          <SrText
            opacity='0.6'
          >
            Even if there’s a Sunlock, you can access the property the old school way, with a key.
          </SrText>
        </SrBox>
        {comboLockboxPhotoUrl &&
          <>
            <SrBox marginTop='32px'>
              <img
                width={isSmallScreen ? '100%' : '450px'}
                height='auto'
                alt='sunlock'
                src={comboLockboxPhotoUrl}
                style={{ borderRadius: '14px' }}
              />
            </SrBox>
            <SrBox marginTop='8px'>
              <SrText
                opacity='0.6'
                fontStyle='italic'
              >
                Photo: The combo lockbox installed on your listing.
              </SrText>
            </SrBox>
          </>
        }
        {!comboLockboxPhotoUrl &&
        <SrFlex width='100%' justify='center' marginTop='35px'>
          <SrFlex
            backgroundColor='rgb(241, 241, 241)'
            width='58px'
            height='65px'
            borderRadius='14px'
            align='center'
            justify='center'
            flexShrink='0'
          >
            <img
              alt='lock icon'
              src='/images/combo-lock-icon.svg'
              height='auto'
              style={{
                filter:
                'drop-shadow(3px 4px 11px rgba(168, 135, 0, 0.18))',
              }}
            />
          </SrFlex>
        </SrFlex>
        }
        <SrBox marginTop='24px'>
          <SrSimpleTextTag title='Combo Lockbox Code' value={comboLockboxCode} />
        </SrBox>
        <SrBox marginTop='16px'>
          <SrInstructionsText instructions={sunlockInstalled
            ? (
              <>
                <SrText
                  letterSpacing='0px'
                  font='greycliff'
                  weight='600'
                  size='16'
                  color='blueGreycliff'
                  lineHeight='24px'
                  display='block'
                >
                  There are two physical keys inside:
                </SrText>
                <SrBox paddingLeft='10px'>
                  <SrText
                    letterSpacing='0px'
                    font='greycliff'
                    weight='600'
                    size='16'
                    color='blueGreycliff'
                    lineHeight='24px'
                    display='block'
                  >
                    1. One is the owner’s key to the original lock.
                    Remember the owner's key doesn't work on the installed Sunlock.
                  </SrText>
                </SrBox>
                <SrBox paddingLeft='8px'>
                  <SrText
                    letterSpacing='0px'
                    font='greycliff'
                    weight='600'
                    size='16'
                    color='blueGreycliff'
                    lineHeight='24px'
                    display='block'
                  >
                    2. The other key unlocks the installed Sunlock.
                    You can use the physical key to open the Sunlock if it happens to run out
                    of battery. Renters will never have access to these keys.
                  </SrText>
                </SrBox>
              </>
            )
            : 'The owner\'s key is in this combo lockbox.'
          }
          />
        </SrBox>
      </SrBox>
    </SrModalV2>
  );
};

SrPartnerComboLockboxInstructionsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  comboLockboxPhotoUrl: PropTypes.string.isRequired,
  comboLockboxCode: PropTypes.string.isRequired,
  sunlockInstalled: PropTypes.bool,
};

SrPartnerComboLockboxInstructionsModal.displayName = 'SrPartnerComboLockboxInstructionsModal';

export default SrPartnerComboLockboxInstructionsModal;
